import request from './request'

//爪点任务
export const getQueryTask = (params) =>
  request({
    url: '/apiDo/member/queryTask',
    method: 'get',
    params,
  })
//领取爪点
export const finishTask = (id) =>
  request({
    url: `/apiDo/member/finishTask?taskId=${id}`,
    method: 'get',
  })

//爪点详情
export const getQueryScoreLog = (data) =>
  request({
    url: '/apiDo/member/queryScoreLog',
    method: 'post',
    data,
  })

export const getUserInfoById = (params) =>
  request({
    url: '/apiDo/member/getMemberInfoById',
    method: 'get',
    params,
  })

export const getUserInfo = () =>
  request({
    url: '/apiDo/member/getMemberInfo',
    method: 'get',
  })

/**
 * 美食
 */

//获取美食详情
export const getFoodDetail = (id) =>
  request({
    url: `/apiDo/food/foodDetail?foodId=${id}`,
    method: 'get',
  })

//美食详情一级评论列表
export const getFoodFirstCommentList = (data) =>
  request({
    url: '/apiDo/foodComment/queryFirstPage',
    method: 'post',
    data,
  })

//美食详情下级评论
export const getFoodNextCommentList = (data) =>
  request({
    url: '/apiDo/foodComment/queryNextPage',
    method: 'post',
    data,
  })
/**
 * 景点
 */
//获取景点详情
export const getSceneryDetail = (id) =>
  request({
    url: `/apiDo/scenery/findSceneryDetail?sceneryId=${id}`,
    method: 'get',
  })

//景点详情一级评论列表
export const getSceneryFirstCommentList = (data) =>
  request({
    url: '/apiDo/scenery/queryFirstPage',
    method: 'post',
    data,
  })

//景点详情下级评论
export const getSceneryNextCommentList = (data) =>
  request({
    url: '/apiDo/scenery/queryNextPage',
    method: 'post',
    data,
  })

/**
 * 物品
 */

//获取物品详情
export const getGoodDetail = (id) =>
  request({
    url: `/apiDo/give/giveDetail?giveId=${id}`,
    method: 'get',
  })

//物品详情一级评论列表
export const getGoodFirstCommentList = (data) =>
  request({
    url: '/apiDo/giveComment/queryFirstPage',
    method: 'post',
    data,
  })
//物品详情下级评论
export const getGoodNextCommentList = (data) =>
  request({
    url: '/apiDo/giveComment/queryNextPage',
    method: 'post',
    data,
  })

/**
 * 纸条
 */
//获取纸条详情
export const getPaperDetail = (id) =>
  request({
    url: `/apiDo/note/noteDetail?noteId=${id}`,
    method: 'get',
  })
//纸条详情一级评论列表
export const getPaperFirstCommentList = (data) =>
  request({
    url: '/apiDo/noteComment/queryFirstPage',
    method: 'post',
    data,
  })
//纸条详情下级评论
export const getPaperNextCommentList = (data) =>
  request({
    url: '/apiDo/noteComment/queryNextPage',
    method: 'post',
    data,
  })
// 景点分页
export const getHotSceneryPage = (data) => {
  return request({
    url: '/apiShow/home/querySceneryPage',
    method: 'post',
    data,
  })
}
// 美食分页
export const getHotFoodPage = (data) => {
  return request({
    url: '/apiShow/home/queryFoodPage',
    method: 'post',
    data,
  })
}
export const getTagTabs = (city, type) => {
  return request({
    url: `/apiShow/home/cityTag?city=${city}&type=${type}`,
    method: 'get',
  })
}
